<script setup lang="ts">

</script>

<template>
  <div class="flex items-center gap-x-2 text-lg text-primary/40">
    <div
      class="flex h-6 w-6 items-center justify-center rounded-full border-2 border-green-500 p-1 text-primary"
    >
      <FontAwesomeIcon icon="cubes" />
    </div>
    <slot />
  </div>
</template>

<style scoped>

</style>